import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { inject, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { ICart } from '@models/payment.model';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { InputComponent } from '@common-components/input/input.component';
import { UtmWalletHundredComponent } from '../utm-wallet-hundred/utm-wallet-hundred.component';
import { DonateBtnComponent } from 'src/app/core/donate-btn/donate-btn.component';

@Component({
  selector: 'app-netbanking',
  templateUrl: './netbanking.component.html',
  styleUrls: ['./netbanking.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    InputComponent,
    UtmWalletHundredComponent,
    DonateBtnComponent
  ]
})
export class NetbankingComponent {

  private util = inject(UtilService);
  public vars = inject(VariablesService);
  public paymentUtil = inject(PaymentUtilService);

  @Input() option;
  @Input() topBank;
  @Input() isOrderLoading;
  @Input() cartDetails: ICart;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  netBankForm: FormGroup;
  banksName: FormControl;

  searchForm: FormGroup;
  searchText: FormControl;
  bankList;

  ngOnInit() {
    this.netBankForm = new FormGroup({
      banksName: this.banksName = new FormControl('', [Validators.required])
    });

    this.searchForm = new FormGroup({
      searchText: this.searchText = new FormControl(''),
    });
  }

  /**Get the keys of bank list object */
  getBankNames(data) {
    return data ? this.util.sortArray(Object.keys(data)) : null;
  }
  /**select the top bank from menu */
  selectTopBank(name) {
    this.banksName.setValue(name);
  }
  /**On click event of top banks */
  submitTopBank() {
    if (this.netBankForm.valid) {
      const data = {
        'mode': 'NB',
        'mode_value': this.banksName.value
      };
      this.dataEmit.emit(data);
    } else {
      this.util.checkValidForm(this.netBankForm);
    }
  }

  search(value) {
    if (!this.bankList) {
      this.bankList = this.option;
    }
    this.option = this.util.filterObject(this.bankList, value);
  }

  resetSearch() {
    this.search('');
    this.searchForm.controls['searchText'].setValue('');
  }
}
